export const PERPAGE_DEFAULT = 10

// "Rows per page" seçicisinin sunduğu boyutlar (Sales listesi).
export const PERPAGE_OPTIONS = [10, 50, 100]
